import gql from "graphql-tag"
import { graphql } from "react-apollo"
import LandingPage from "."

const query = gql`
  query DefaultRoute {
    user {
      id
      umbrellaEntity {
        ... on Network {
          __typename
          facilities {
            id
            name
            departments {
              id
              name
            }
            units {
              id
              name
            }
          }
        }
        ... on Facility {
          __typename
          id
        }
        ... on Department {
          __typename
          facility {
            id
          }
        }
      }
    }
  }
`

const LandingPageWithStore = graphql(query, {
  props: ({ data: { error, loading, user } }) => {
    if (error) {
      throw error
    }
    if (loading) {
      return { loading }
    }
    if (!user.umbrellaEntity) {
      throw Error("404")
    }

    const managedFacilities = []
    if (user.umbrellaEntity.facilities) {
      user.umbrellaEntity.facilities.forEach(facility => {
        managedFacilities.push({
          id: facility.id,
          name: facility.name,
          departments: facility.departments.length,
          units: facility.units.length,
        })
      })
    } else {
      managedFacilities.push({
        id: user.umbrellaEntity.id
          ? user.umbrellaEntity.id
          : user.umbrellaEntity.facility.id,
      })
    }
    return { facilities: managedFacilities }
  },
})(LandingPage)

export default LandingPageWithStore
